// extracted by mini-css-extract-plugin
module.exports = {"content__container":"Feeds_content__container__1a6qP","content":"Feeds_content__25ggg"};